var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5718 7.98518C25.5411 6.23585 21.6658 7.27518 19.9151 10.3059L15.4998 17.9532C14.2224 20.1612 15.8671 20.9332 17.7004 22.0325L21.9484 24.4845C23.3871 25.3145 25.2244 24.8218 26.0538 23.3852L30.5918 15.5258C32.1171 12.8852 31.2124 9.50985 28.5718 7.98518Z",
    fill: "#E64A19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5765 11.151L19.3285 8.69903C16.9838 7.39703 15.6558 7.31103 14.6925 8.8417L8.42713 19.6917C6.6778 22.7204 7.71913 26.5937 10.7478 28.339C13.3885 29.8637 16.7638 28.959 18.2885 26.3184L24.6738 15.2584C25.5071 13.8204 25.0151 11.981 23.5765 11.151Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.394 5.5726L21.41 3.84927C18.11 1.9446 13.89 3.07394 11.9853 6.37394L6.30464 16.2133C5.4653 17.6646 5.96397 19.5226 7.4153 20.3599L10.7566 22.2893C12.4066 23.2426 14.516 22.6773 15.4693 21.0266L21.9593 9.7866C23.304 7.4586 26.28 6.6606 28.6086 8.00527L24.394 5.5726Z",
    fill: "#43A047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7924 9.18909L9.5671 7.33109C8.12843 6.50309 6.2911 6.99376 5.46177 8.42842L1.59243 15.1151C-0.312233 18.4058 0.817101 22.6164 4.1171 24.5158L6.57243 25.9298L9.55043 27.6451L10.8431 28.3884C8.54843 26.8524 7.81977 23.7751 9.2231 21.3518L10.2251 19.6211L13.8944 13.2811C14.7218 11.8511 14.2291 10.0171 12.7924 9.18909Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.78ba944d647738a4f270981085f64e54.svg";
export { ForwardRef as ReactComponent };